import { IntlShape } from "react-intl";

export const getMainFilterOptions = (intl: IntlShape) => [
  { value: "name", label: intl.formatMessage({ id: "usAdmin.name" }) },
  {
    value: "contactName",
    label: intl.formatMessage({ id: "usAdmin.contactName" }),
  },
  { value: "address", label: intl.formatMessage({ id: "usAdmin.address" }) },
  { value: "city", label: intl.formatMessage({ id: "usAdmin.city" }) },
  { value: "state", label: intl.formatMessage({ id: "usAdmin.state" }) },
  { value: "country", label: intl.formatMessage({ id: "country" }) },
  { value: "zip", label: intl.formatMessage({ id: "usAdmin.zip" }) },
  { value: "phone", label: intl.formatMessage({ id: "usAdmin.phone" }) },
  { value: "email", label: intl.formatMessage({ id: "usAdmin.email" }) },
  {
    value: "industrySpecialist",
    label: intl.formatMessage({ id: "usAdmin.industrySpecialist" }),
  },
  {
    value: "territoryManager",
    label: intl.formatMessage({ id: "usAdmin.territoryManager" }),
  },
  {
    value: "distributor",
    label: intl.formatMessage({ id: "usAdmin.distributor" }),
  },
  {
    value: "automatedRg",
    label: intl.formatMessage({ id: "usAdmin.automatedRg" }),
  },
];

export const END_USER_TABLE = {
  MOBILE_ROWS: 10,
  MOBILE_COLUMNS: 1,
  DESKTOP_ROWS: 10,
  DESKTOP_COLUMNS: 11,
};

export const END_USER_SORT_KEYS = {
  NAME: "name",
  CONTACT_NAME: "contactName",
  ADDRESS: "address",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  PHONE: "phone",
  EMAIL: "email",
  INDUSTRY_SPECIALIST: "industrySpecialist",
  TERRITORY_MANAGER: "territoryManager",
  DISTRIBUTOR: "distributor",
  AUTOMATED_RG: "automatedRg",
  COUNTRY: "country",
};
